<script>
  import * as restfulService from '../../../../../../../app/services/restfulService'
  import * as notifyService from '../../../../../../../app/services/notifyService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'

  import swal from 'sweetalert2'

  export default {
    mixins: [helpers],
    name: 'paper-show-evaluation-responses',
    props: ['paper', 'reviews', 'evaluationType'],
    data () {
      return {
        isSubmitted: false
      }
    },
    computed: {
      averageEvaluations: function () {
        let totalEvaluations = 0
        let evaluations = 0
        this.reviews.forEach((item) => {
          if (item.responses.length) {
            item.responses.forEach((response) => {
              totalEvaluations++
              evaluations += parseFloat(response.value)
            })
          }
        })
        if (totalEvaluations > 0) {
          return (evaluations / totalEvaluations).toFixed(2)
        }
        return 'Aguardando avaliações'
      },
      paperStatusKey: function () {
        return this.paper.status.key
      }
    },
    methods: {
      cancelEvaluation (review) {
        bus.$emit('show-loader')
        this.isSubmitted = true
        let data = {
          id: review.id
        }
        restfulService.put('paper_review', 'cancel', data.id, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            bus.$emit('papers-reload-list')
            this.isSubmitted = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.isSubmitted = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      resetEvaluation (review) {
        swal({
          title: 'Deseja realmente remover as notas dessa avaliação?',
          text: 'Essa ação não pode ser revertida, o avaliador terá que preencher todas as notas dos critérios novamente!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, continuar!'
        })
          .then(() => {
            bus.$emit('show-loader')
            this.isSubmitted = true
            let data = {
              id: review.id
            }
            restfulService.put('paper_review', 'reset', data.id, data)
              .then(() => {
                notifyService.success({hideLoader: true})
                bus.$emit('papers-reload-list')
                this.isSubmitted = false
                bus.$emit('hide-loader')
              })
              .catch(e => {
                this.isSubmitted = false
                bus.$emit('hide-loader')
                console.log(e)
              })
          })
          .catch(e => {
            this.isSubmitted = false
            bus.$emit('hide-loader')
          })
      },
      averageResponsesEvaluation (item) {
        let totalEvaluations = 0
        let evaluations = 0
        item.responses.forEach((response) => {
          totalEvaluations++
          evaluations += parseFloat(response.value)
        })
        if (totalEvaluations > 0) {
          return (evaluations / totalEvaluations).toFixed(2)
        }
        return 0
      }
    }
  }
</script>

<template>
    <table class="table-confirmation" v-if="reviews.length > 0">
        <thead>
        <tr>
            <th>Avaliações</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td>
                <table class="table-confirmation">
                    <tbody>
                    <tr v-for="item in reviews"
                        v-bind:class="{'danger-row': !item.evaluation_action && (item.last_action.status.key === 'rejeitado' || item.last_action.status.key === 'cancelado')}">
                        <td>
                            {{item.registration.person.pessoa.nome}}
                            <div style="padding-top: 5px;" v-if="item.last_action.notes">
                                <strong>Observações do Avaliador:</strong> {{item.last_action.notes}}
                            </div>
                        </td>
                        <td v-if="item.evaluation_action">
                            {{averageResponsesEvaluation(item)}}
                        </td>
                        <td v-if="item.evaluation_action">
                            {{item.last_action.created_at | dateTimeEnToBr}}
                        </td>
                        <td v-if="!item.evaluation_action" colspan="2">
                            <span v-if="item.last_action.status.key === 'rejeitado'">Rejeitado pelo avaliador</span>
                            <span v-if="item.last_action.status.key === 'cancelado'">Avaliação cancelada</span>
                            <span v-if="item.last_action.status.key === 'atribuido' || item.last_action.status.key === 'aceito'">
                                Aguardando avaliação
                            </span>
                        </td>
                        <td width="50">
                            <el-button type="warning"
                                       size="small"
                                       title="Remover notas da avaliação"
                                       v-if="item.last_action.status.key === 'avaliado' && !evaluationType.evaluation_finished && (paperStatusKey !== 'finalizado' && paperStatusKey !== 'aguardando_publicacao')"
                                       @click="resetEvaluation(item)">
                                <i class="fa fa-minus-circle"></i>
                            </el-button>
                            <el-button type="danger"
                                       size="small"
                                       title="Cancelar essa avaliação"
                                       v-if="(item.last_action.status.key === 'atribuido' || item.last_action.status.key === 'aceito') && !evaluationType.evaluation_finished"
                                       @click="cancelEvaluation(item)">
                                <i class="fa fa-trash"></i>
                            </el-button>
                        </td>
                    </tr>
                    <tr>
                        <td align="right"><strong>Média</strong></td>
                        <td colspan="2">{{averageEvaluations}}</td>
                        <td></td>
                    </tr>
                    </tbody>
                </table>
            </td>
        </tr>
        </tbody>
    </table>
</template>



// WEBPACK FOOTER //
// Responses.vue?d5ba07e6